/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {WarningsEnum} from '../warnings/warnings.enum';

@Component({
    selector: 'app-drag-and-drop',
    templateUrl: './drag-and-drop.component.html',
    styleUrls: ['./drag-and-drop.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DragAndDropComponent implements OnChanges {
    @Output() fileDropped = new EventEmitter<File>();
    @Input() disable: boolean;
    @Input() label: string;
    @Input() warningLevel: WarningsEnum = WarningsEnum.INFO;
    @Input() uploadAreaLabel: string;
    WarningEnum = WarningsEnum;
    form = this.formBuilder.group({
        fileDropInput: new UntypedFormControl()
    });

    constructor(private formBuilder: UntypedFormBuilder) {
    }

    onFileDropped(files: File[]): void {
        for (const file of files) {
            this.fileDropped.emit(file);
        }
    }

    change(event: any): void {
        this.onFileDropped(event.target.files);
        this.clearFormValue();
    }

    clearFormValue(): void {
        this.form.get('fileDropInput').setValue(null);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['disable']) {
            if (changes['disable'].currentValue) {
                this.form.get('fileDropInput').disable();
            } else {
                this.form.get('fileDropInput').enable();
            }
        }
    }

}
